export default __webpack_public_path__ + "static/media/jedphotologo.69441f38.jpg";